import { render, staticRenderFns } from "./rightManDialog.vue?vue&type=template&id=0bb45aac&scoped=true&"
import script from "./rightManDialog.vue?vue&type=script&lang=js&"
export * from "./rightManDialog.vue?vue&type=script&lang=js&"
import style0 from "./rightManDialog.vue?vue&type=style&index=0&id=0bb45aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb45aac",
  null
  
)

export default component.exports